import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { hideVisually } from '../../styles/style-mixins';
import { CLASS_DISABLED } from './constants';
const baseStyles = ({ theme }) => css `
  display: inline-block;
  margin-right: ${theme.spacings.bit};
  margin-bottom: ${theme.spacings.bit};
  margin-left: ${theme.spacings.bit};
  font-weight: ${theme.fontWeight.bold};

  [disabled] &,
  .${CLASS_DISABLED} & {
    color: var(--cui-fg-normal-disabled);
  }
`;
const hiddenStyles = ({ hideLabel }) => hideLabel && hideVisually();
const Text = styled('span')(baseStyles, hiddenStyles);
const optionalStyles = ({ theme }) => css `
  color: var(--cui-fg-subtle);
  font-weight: ${theme.fontWeight.regular};
  font-style: italic;

  [disabled] &,
  .${CLASS_DISABLED} & {
    color: var(--cui-fg-subtle-disabled);
  }
`;
const Optional = styled('span')(optionalStyles);
/**
 * @private
 */
export function FieldLabelText({ label, hideLabel, optionalLabel, required, }) {
    return (_jsxs(Text, Object.assign({ hideLabel: hideLabel }, { children: [label, optionalLabel && !required ? (_jsx(Optional, { children: ` (${optionalLabel})` })) : null] })));
}
